<div class="cover-photo-container">
    <img decoding="async" src="/assets/srec-cover-photo-cropped.png" class="cover-photo"
        alt="Spruce-SREC-Cover-Photo" />
</div>
<div class="container">
    <h2 style="text-align: center;">You have successfully submitted the SREC Form. Your reference number is
        {{refNumber}}.</h2>
    <button class="button" mat-flat-button [routerLink]="['/']">
        Return to Home
    </button>
</div>